import { Component, EventEmitter, HostBinding, Input, Output } from '@angular/core';
import { CalendarEventItem } from 'src/app/models/ExamsAndTasksCalendar/calendarEventItem';

@Component({
  selector: 'app-event',
  templateUrl: './event.component.html',
  styleUrls: ['./event.component.scss']
})
export class EventComponent {
  @Input({ required: true }) event!: CalendarEventItem;
  @HostBinding('style.--event-color') @Input() color!: string;
  @Output() open: EventEmitter<void> = new EventEmitter<void>();
  openedNotifications: boolean = false;

  openEvent(e: Event) {
    e.preventDefault();

    this.open.emit();
  }

  isTimeEmpty(dateTime: string): boolean {
    return dateTime.endsWith('T00:00:00Z');
  }
}
